import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getUserMetadataBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getUserMetadata.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getUserMetadata.fulfilled, (state, action) => {
      state.user.blocked = action.payload.externalId || '';
      state.user.alreadySpeakTotal = action.payload.email || '';
      state.isBusy = false;
    })
    .addCase(actions.getUserMetadata.rejected, (state) => {
      state.isBusy = false;
    });
};

export const getAllUsersMetadataBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getAllUsersMetadata.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getAllUsersMetadata.fulfilled, (state, action) => {
      if (action.payload.withReset) {
        state.spokeUsersMetaData.usersData = action.payload.data;
      } else {
        state.spokeUsersMetaData.usersData = [...state.spokeUsersMetaData.usersData, ...action.payload.data];
      }

      state.spokeUsersMetaData.totalCount = action.payload.totalCount || 0;
      state.spokeUsersMetaData.nextPage = action.payload.next || '';
      state.isBusy = false;
    })
    .addCase(actions.getAllUsersMetadata.rejected, (state) => {
      state.isBusy = false;
    });
};
